import React from "react";
import { useTranslation } from "react-i18next";
import "./css/ManualCorrectionWarning.css";

/**
 * Warning shown when the admin has turned automatic account correction off.
 * Matches the client ManualCorrectionWarning: a red notice, with a traveling
 * border highlight while a related MT5 balance is below zero.
 */
const ManualCorrectionWarning = ({ animate = false, extraMessage = null }) => {
  const { t } = useTranslation("mobile");

  return (
    <div
      className={`manual-correction-warning${animate ? " is-animated" : ""}`}
      role="status"
    >
      <div className="manual-correction-warning__icon" aria-hidden>
        <i className="fa-solid fa-triangle-exclamation" />
      </div>
      <div className="manual-correction-warning__body">
        <strong>{t("manual_correction_not_automated")}</strong>
        <p>{t("manual_correction_description")}</p>
        {extraMessage ? (
          <p className="manual-correction-warning__extra">{extraMessage}</p>
        ) : null}
      </div>
    </div>
  );
};

export default ManualCorrectionWarning;
